export default function InfoField({ icon, label, children, className = "" }) {
    return (
        <div className={`w-full rounded-2xl bg-[#F2F2F2] px-4 py-3 ${className}`}>
            <div className="flex items-center gap-2 text-sm font-medium">
                {icon}
                <span className="uppercase tracking-wide text-gray-900">{label}</span>
            </div>
            <div className="mt-2">{children}</div>
        </div>
    );
}